module.exports = __webpack_public_path__ + "img/meatbingo20260310.c12cb717.jpg";